import { Link } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';
import type { TKey } from '~/lib/i18n-locales';
import { faqsData } from '~/modules/marketing/marketing-config';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '~/modules/ui/accordion';

export function FAQ() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-3xl">
      <Accordion className="w-full">
        {faqsData.map((faq, index) => {
          const question = `about:faq.question_${index + 1}` as TKey;
          const answer = `about:faq.answer_${index + 1}` as TKey;

          return (
            <AccordionItem key={faq.id} value={faq.id}>
              <AccordionTrigger className="px-3 text-left text-xl">{t(question)}</AccordionTrigger>
              <AccordionContent className="px-3 pb-8 text-lg">
                <Trans
                  t={t}
                  i18nKey={answer as never}
                  components={{
                    Link: (
                      <Link
                        to={faq.link}
                        aria-label={`Visit ${faq.link}`}
                        target={faq.link?.startsWith('https:') ? '_blank' : '_self'}
                        className="link-inline"
                      />
                    ),
                  }}
                />
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
}
